import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { Auth } from 'aws-amplify';

import { PatientService } from '../../../services/patient.service';
import { PatientData } from '../../types/patient-data';
import { TopNavServiceService } from './top-nav-service.service';
import {AdminService} from '../../../services/admin.service';
import {BasicAgency} from '../../../services/rest-api.service';
import {NavigatorService} from '../../../services/navigator';
import {ToastService} from "../messaging/toast/toast.service";

@Component({
  selector: 'nav[top-nav]',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
  host: {
    class: 'navbar navbar-expand-sm navbar-light bg-white celerity-top-nav'
  }
})
export class TopNavComponent implements OnInit {
  currentPatient: PatientData;
  currentAgency: BasicAgency;
  faUserCircle = faUserCircle;
  adminActingAsPatient = false;

  constructor(private router: Router, private patient: PatientService, private admin:AdminService,
              private topNavService: TopNavServiceService, private navigator:NavigatorService,
              private toast: ToastService) {}

  get isNavbarCollapsed(): boolean {
    return this.topNavService.isNavbarCollapsed;
  }

  ngOnInit(): void {
    this.currentAgency = this.patient.currentAgency;
    this.currentPatient = this.patient.currentPatient;
    this.adminActingAsPatient = !!this.admin.actAsPatientId;
    this.patient.patientChanged$.subscribe(patient => {
      this.currentPatient = patient;
      this.adminActingAsPatient = !!this.admin.actAsPatientId;
    });
  }

  toggleCollapsed() {
    this.topNavService.toggleNavbarCollapse();
  }

  signOut() {
    Auth.signOut().then(() => {
      this.topNavService.closeNavbar();
      delete this.admin.actAsPatientId;
      this.patient.currentPatient = null;
      return this.router.navigateByUrl('/auth/landing');
    });
  }

  backToAdmin() {
    this.topNavService.closeNavbar();
    delete this.admin.actAsPatientId;
    this.toast.removeAll();
    return this.router.navigateByUrl('/auth/landing');
  }

  goHome() {
    return this.navigator.redirectToHomePage(this.patient.currentPatient, true);
  }
}
